import wire from '../wire';
import template from './uploads.html';
import ModalUploadEventController from './modal-upload-event';

const PAGE_SIZE = 10;

class UploadsController {
  constructor($rootScope, $http, $q, toaster, $state, $uibModal, ConfirmDialog) {
    'ngInject';

    this.account = $rootScope.account;
    this.$http = $http;
    this.toaster = toaster;
    this.$q = $q;
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.ConfirmDialog = ConfirmDialog;

    this.FeatureFlags = $rootScope.account.feature_flags;
    this.canUploadBroadcasts =
      $rootScope.user.can('create', 'broadcast') &&
      $rootScope.user.can('create', 'broadcast/*:upload');

    if (this.canUploadBroadcasts) {
      this.slot = 'broadcast';
    } else {
      this.slot = 'preview';
    }

    this.file = null;
    this.uploadingPromises = {};
    this.reload();
  }

  reload() {
    this.loadUploadsForPage(1);
  }

  changeSlot(slot) {
    this.slot = slot;
    if (this.slot != 'broadcast' && this.slot != 'template') {
      this.reload();
    }
  }

  loadUploadsForPage(p) {
    const { $http, toaster } = this;

    this.uploads = [];
    this.loading = true;

    const params = {
      p: Math.max(0, p - 1),
      l: PAGE_SIZE,
      s: '-created_at',
    };
    if (this.slot) {
      params['filter.slot'] = this.slot;
    }
    $http
      .get(`${API_ROOT}/account/uploads`, { params: params })
      .then((response) => {
        this.uploads = response.data;
        var pagination = JSON.parse(response.headers('x-pagination'));
        this.pagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + response.data.length,
        };
      })
      .catch((err) => {
        toaster.pop('warning', 'Unable to load uploads. Please refresh the page and try again.');
      })
      .finally(() => {
        this.loading = false;
      });
  }

  delete(upload) {
    const { ConfirmDialog, $http, toaster } = this;

    let modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Delete Upload',
      actionButtonClass: 'danger',
      headerText: 'Please Confirm',
      bodyText: 'Are you sure you want to delete this upload? It will no longer be accessible.',
    };

    ConfirmDialog.show(modalOptions).then(() => {
      $http
        .delete(`${API_ROOT}/account/uploads/${upload.id}`)
        .then((response) => {
          toaster.pop('success', 'The upload was successfully deleted.');
        })
        .then(() => {
          this.reload();
        })
        .catch((error) => {
          console.error(error);
          toaster.pop(
            'warning',
            'An error occurred while trying to delete the upload. Please refresh and try again.'
          );
        });
    });
  }

  upload(file) {
    file.upload().then((result) => {
      console.log('Uploaded', result);
      this.file = null;
      this.reload();
    });
  }

  uploadEventVideo() {
    const { $uibModal, $state } = this;
    $uibModal
      .open({
        template: require('./modal-upload-event.html'),
        controllerAs: 'vm',
        controller: ModalUploadEventController,
        size: 'lg',
        //  Prevent accidental close...
        backdrop: 'static',
        keyboard: false,
        resolve: {
          broadcast: () => null,
          highlights: () => [],
        },
      })
      .result.then((broadcast) => {
        $state.go('events.detail', { id: broadcast.id });
      });
  }

  openViewModal(f) {
    const { $uibModal } = this;
    const file = f;
    $uibModal.open({
      template: require('./modal-view-upload.html'),
      controllerAs: 'vm',
      controller: function ($uibModalInstance) {
        this.file = file;
        this.isImage = this.file.mimetype.startsWith('image');
        this.isVideo = this.file.mimetype.startsWith('video');
        this.isPDF = this.file.mimetype.startsWith('application/pdf');

        this.cancel = () => $uibModalInstance.dismiss('cancel');
      },
    });
  }
}

export default wire('uploads', template, UploadsController, 'UploadsController');



// WEBPACK FOOTER //
// ./app/pages/uploads/_index.js